import * as React from 'react';

import { EStatus } from '../../types/context';
import { useContext } from '../../utils/useContext';
import { EarlyAccessPaywallModalContainer } from '../EarlyAccessPaywallModalContainer';
import { FallbackModalContainer } from '../FallbackModalContainer';

export const RootContainer: React.FC = () => {
  const context = useContext();

  if (context.status === EStatus.Succeed) {
    return <EarlyAccessPaywallModalContainer />;
  }

  if (!context.open) {
    return null;
  }

  return <FallbackModalContainer />;
};
